// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RgPwN","title":"styles_title__2BU2c"};